import EntityInputField from 'vue-forms/components/EntityInputField';
import WorkgroupService from 'app/services/WorkgroupService';

export default {
  mixins: [ EntityInputField ],

  props: {
    service: {
      default: () => WorkgroupService
    },

    idField: {
      default: 'id'
    },
  },

  methods: {
    customLabel(item) {
      return item.name;
    },

    customTags(item) {
      const ret = [];
      if (!item.type) {
        ret.push({
          text: 'Indiretto',
          variant: 'secondary'
        });
      } else if (item.type === 'ADMINISTRATOR') {
        ret.push({
          text: 'Amministrato',
          variant: 'primary'
        });
      } else if (item.type === 'ORDINARY') {
        ret.push({
          text: 'Ordinario',
          variant: 'success'
        });
      } else if (item.type === 'GUEST') {
        ret.push({
          text: 'Ospite',
          variant: 'warning'
        });
      }
      return ret;
    }
  }
};
